<template>
  <div class="col-9 col-lg-10 mt-1 p-4 exam-modify" v-if="singleExam != null">
    <div v-if="singleExam.practices" class="question-amount">{{$t('exam_quantity')}}:{{singleExam.practices.length}}
      <button v-show="modifyCount===-1" class="edit-btn" @click="addExam">+</button>
    </div>
    <div v-show="modifyCount===-1" class="create-title">
      <div class="form-group">
        <label>{{$t('exam_name')}}:</label>
        <input class="form-control question-group" placeholder="請輸入題組名稱" type="text" :change="inputCheck()" v-model="singleExam.name">
        <span class="callout">
          Only letters, numbers, underscores (_) are allowed!
        </span>
      </div>
    </div>

    <draggable  ghost-class="ghost"  v-show="modifyCount===-1" v-model="singleExam.practices" @start="drag=true" @end="sortNum"  class="list-group">
      <div v-for="(exam , num) in singleExam.practices" :key="num" class="d-flex justify-content-between align-items-center list-group-item examlist my-2">
        <p class="examlist-title">{{$t('exam')}}:{{exam.sort+1}} {{exam.title}}</p>
        <div class="btn-group" role="group">
          <button type="button" class="btn btn-secondary" @click="goEdit(num)" >{{$t('modify')}}</button>
          <button type="button" class="btn btn-secondary" @click="deleteExam(num)" >{{$t('delete')}}</button>
        </div>
      </div>
    </draggable>

    <div class="exam" v-show="modifyCount === num" v-for="(item,num) in singleExam.practices" :key="num">
      <div class="form-group">
        <label>{{$t('exam')}}{{num*1+1}}</label>
        <textarea class="form-control" rows="4" placeholder="請填寫題目" v-model="singleExam.practices[num].title"></textarea>
      </div>

      <div>
        <input class="form-control my-2" v-model="singleExam.practices[num].videoUrl" placeholder="請填寫影片網址">
        <input class="form-control my-2" v-model="singleExam.practices[num].imageUrl" placeholder="請填寫圖片網址">
      </div>

      <div class="form-group">
        <label for="exampleFormControlSelect1">{{$t('exam_type')}}:</label>
        <select v-model="singleExam.practices[num].examType" class="form-control">
          <option value="single">{{$t('multiple_choice')}}</option>
          <option value="multiple">{{$t('multiple_selection')}}</option>
        </select>
      </div>

      <div class="form-group row">
        <div class="col-6">
          <label>{{$t('option')}}:</label>
          <button class="edit-btn" @click="addItem(num)">+</button>
          <button class="edit-btn" @click="reduceItem(num)">-</button>
          <div class="d-flex" v-for="(item,index) in singleExam.practices[num].items" :key="index">
            <span class="my-auto mx-2"> {{String.fromCharCode(65 + index)}}.</span>
            <input class="form-control my-2" v-model="singleExam.practices[num].items[index]" placeholder="請填寫選項">
          </div>
        </div>

        <div v-if="singleExam.practices[num].examType === 'multiple'" class="form-group col-6">
          <label for="exampleFormControlSelect1">{{$t('anwser')}}:</label>
          <select class="form-control mt-2" v-model="singleExam.practices[num].answers" multiple>
            <option v-for="(item,index) in singleExam.practices[num].items" :key="index">{{String.fromCharCode(65 + index)}}</option>
          </select>
        </div>

        <div v-if="singleExam.practices[num].examType === 'single'" class="form-group col-6">
          <label for="exampleFormControlSelect1">{{$t('anwser')}}:</label>
          <select class="form-control mt-2" v-model="singleExam.practices[num].answers">
            <option v-for="(item,index) in singleExam.practices[num].items" :key="index">{{String.fromCharCode(65 + index)}}</option>
          </select>
        </div>
      </div>
    </div>

    <button class="btn btn-secondary mx-2" v-show="modifyCount > -1" @click="goList">{{$t('back')}}</button>
    <button class="btn btn-secondary mx-2" @click="modifyExam($route.params.id, singleExam)">{{$t('finish')}}</button>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import api from '../api.js'
export default {
  name: 'ExamModify',
  components: {
    draggable
  },
  data () {
    return {
      singleExam: null,
      modifyCount: -1,
      itemQuantity: 4
    }
  },
  mixins: [api],
  mounted () {
    console.log(this.singleExam)
    this.getSingleExam(this.$route.params.id)
  },
  methods: {
    addExam () {
      let index = this.singleExam.practices.length
      let newExam = {
        'sort': index,
        'title': '',
        'answers': [],
        'items': [],
        'examType': 'single',
        'videoUrl': '',
        'imageUrl': ''
      }
      for (let i = 0; i < this.itemQuantity; i++) {
        newExam['items'].push('')
      }
      this.singleExam.practices.push(newExam)
    },
    goList () {
      this.resetPosition()
      this.modifyCount = -1
    },
    deleteExam (num) {
      this.resetPosition()
      if (this.modifyCount === -1) {
        this.singleExam.practices.splice(num, 1)
      } else {
        this.singleExam.practices.splice(this.modifyCount, 1)
      }
      this.modifyCount = -1
      this.sortNum()
      if (this.singleExam.practices.length === 0) {
        this.removeExam(this.$route.params.id)
      }
    },
    sortNum () {
      for (let i = 0; i < this.singleExam.practices.length; i++) {
        this.singleExam.practices[i].sort = i
      }
    },
    goEdit (num) {
      this.modifyCount = num
    },
    addItem (num) {
      this.singleExam.practices[num].items.push('')
    },
    reduceItem (num) {
      if (this.singleExam.practices[num].items.length > 2) this.singleExam.practices[num].items.pop()
    },
    inputCheck () {
      if (this.singleExam.name) { this.singleExam.name = this.singleExam.name.replace(/[^\w_]/g, '') }
    },
    resetPosition () {
      window.document.body.scrollTop = 0
      window.document.documentElement.scrollTop = 0
    }
  }
}
</script>
<style lang="scss" scoped>
  .question-amount {
    text-align: left;
  }
  .exam-modify {
    min-height: 100vh;
    margin: auto;
    width: 100%;
    font-size: 1.25rem;
    background-color: #f7f7f7;
  }
  .edit-btn {
    font-size: 1rem;
    outline: none;
    border: none;
    background: rgba(90, 90, 90, 1);
    color: white;
    height: 2em;
    width: 2em;
    margin: 0em .25em;
    border-radius: 1.5em;
    box-shadow: 0.1em  0.2em 0.5em -0.25em rgba(0,0,0,1);
  }
  .edit-btn:active {
    box-shadow: inset 0.1em  0.2em 0.5em -0.25em rgba(0,0,0,1)
  }
  .examlist {
    cursor: pointer;
    border-radius: 10px;
  }
  .examlist-title {
    text-align: left;
    width: 70%;
    text-overflow:ellipsis;
    overflow:hidden;
    white-space: nowrap;
    margin: 0;
  }
  .examlist:hover {
    transform: scale(1.03);
    transition: transform 200ms linear;
  }
  .question-group {
    height: 60px;
    font-size: 1.25rem;
  }
  .question-group:focus {
    transform: scale(1.02);
    transition: transform 200ms linear;
  }
  .ghost {
    opacity: .8;
    background-color: rgb(136, 207, 255);
  }
  .callout {
    left: 15px;
  }
</style>
